import AmplifyWrapper from '../service/auth.service';

export const RESEND_CONFIRMATION_CODE = 'RESEND_CONFIRMATION_CODE';
export const RESEND_CONFIRMATION_CODE_SUCCESS = 'RESEND_CONFIRMATION_CODE_SUCCESS';
export const RESEND_CONFIRMATION_CODE_ERROR = 'RESEND_CONFIRMATION_CODE_ERROR';

const requestResendConfirmationCode = username => {
	return {
		type: RESEND_CONFIRMATION_CODE,
		username
	};
};

const recieveResendConfirmationCodeSuccess = data => {
	return {
		type: RESEND_CONFIRMATION_CODE_SUCCESS,
		data
	};
};

const recieveResendConfirmationCodeError = errors => {
	return {
		type: RESEND_CONFIRMATION_CODE_ERROR,
		errors
	};
};

export const resendConfirmationCode = username => {
	return async function(dispatch) {
		//
		dispatch(requestResendConfirmationCode(username));
		//
		AmplifyWrapper.resendSignUp(username)
			.then(data => {
				dispatch(recieveResendConfirmationCodeSuccess(data));
			})
			.catch(error => {
				dispatch(recieveResendConfirmationCodeError(error));
			});
	};
};
